/** Clinical category of the procedure */
export enum ProcedureCategory {
  INTERVENTION = 'intervention',
  ANESTHESIA = 'anesthesia',
  REPAIR = 'repair',
  MONITORING = 'monitoring',
}

/** Common labor procedures — use a string for unlisted procedures */
export enum ProcedureName {
  AMNIOTOMY = 'amniotomy',
  FOLEY_BULB = 'foley-bulb',
  EPIDURAL_PLACEMENT = 'epidural-placement',
  SUTURING = 'suturing',
  FSE_IUPC = 'fse-iupc',
}

export interface Procedure {
  /** Procedure name — use ProcedureName enum values or a custom string */
  procedureName: ProcedureName | string
  /** Clinical category of the procedure */
  category: ProcedureCategory
  /** Unix timestamp (ms) when the procedure began */
  startTime: number
  /** Unix timestamp (ms) when the procedure was completed */
  endTime?: number
  /** UUID of the clinician performing the procedure */
  providerId: string
  /** UUID of the assisting clinician (e.g. for repairs) */
  assistantId?: string
  /** Dynamic procedure-specific details (e.g. "Suture Material", "Fluid Color", "Catheter Size") */
  details: Record<string, string>
  /** Whether the procedure was completed successfully */
  isSuccessful: boolean
  /** Whether informed consent was obtained — required for medical-legal documentation */
  consentObtained: boolean
}
